import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiService } from '@/services/api'
import { toast } from 'sonner'
import { Loader2 } from 'lucide-react'

const ERROR_MESSAGES: Record<string, string> = {
  google_not_configured: 'Login com Google não está configurado.',
  google_state_mismatch: 'Falha de segurança na autenticação. Tente novamente.',
  google_token_exchange_failed: 'Não foi possível autenticar com o Google. Tente novamente.',
  google_userinfo_failed: 'Não foi possível obter informações do Google. Tente novamente.',
  google_no_email: 'Sua conta Google não possui um e-mail verificado.',
  google_internal: 'Tivemos um problema interno ao concluir seu login. Tente novamente em instantes.',
  access_denied: 'Você cancelou o login com o Google.',
}

export function GoogleCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const token = searchParams.get('token')
    const error = searchParams.get('error')

    if (error) {
      const message = ERROR_MESSAGES[error] ?? 'Erro ao autenticar com o Google.'
      toast.error(message)
      navigate('/login', { replace: true })
      return
    }

    if (token) {
      apiService.setToken(token)
      toast.success('Login com Google realizado com sucesso!')
      // Convite pendente (link/QR da campanha): retoma o ingresso pós-login
      const pendingInvite = sessionStorage.getItem('pending_invite_code')
      navigate(pendingInvite ? `/convite/${pendingInvite}` : '/pagina-inicial', { replace: true })
      return
    }

    // Nenhum token nem erro: algo inesperado
    toast.error('Resposta inesperada do servidor.')
    navigate('/login', { replace: true })
  }, [searchParams, navigate])

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <Loader2 className="h-10 w-10 animate-spin text-primary" />
      <p className="text-muted-foreground font-medium">Autenticando com Google...</p>
    </div>
  )
}
